import { Box } from '@mui/material'
import React from 'react'
import { IconWrapperProps } from './IconWrapper.config'
import styles from './IconWrapper.module.scss'

const IconWrapper = (props: IconWrapperProps) => {
  return (
    <Box className={styles.iconContainer}>
      {props.icon}
    </Box>
  )
}

export default IconWrapper